import React from "react";

export const Services = (props) => {
  return (
    <section id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Hizmetlerimiz</h2>
          <p style={{ color: "white" }}>
            TR Assist olarak kurumsal müşterilerimize ve sigorta şirketlerine 
            profesyonel yol yardım ve ikame araç hizmetleri sunuyoruz.
          </p>
        </div>
        <div className="row services-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-xs-12 col-sm-6 col-md-4 service-col">
                  <div className="service-card">
                    <i className={d.icon} aria-hidden="true"></i>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </section>
  );
};
